import { Link } from "react-router-dom";
import { HomeIcon, ChevronRight, MapPin, Info } from "lucide-react";
import { Button } from "../../../components/ui/button";

export const PropertyHeader = ({
  address,
  city,
  state,
  county,
  onDetailsClick,
}) => {
  return (
    <div className="space-y-4">
      {/* Breadcrumbs */}
      <nav className="flex items-center gap-2 text-xs sm:text-sm flex-wrap">
        <Link
          to={"/"}
          className="flex items-center gap-1 text-muted-foreground hover:text-primary transition-colors"
        >
          <HomeIcon className="h-3 w-3 sm:h-4 sm:w-4" />
          <span>Home</span>
        </Link>
        <ChevronRight className="h-3 w-3 sm:h-4 sm:w-4 text-muted-foreground" />
        <Link
          to={"/search"}
          className="text-muted-foreground hover:text-primary transition-colors"
        >
          <span>Search</span>
        </Link>
        <ChevronRight className="h-3 w-3 sm:h-4 sm:w-4 text-muted-foreground" />
        <span className="text-foreground font-medium truncate max-w-md">
          {address}
        </span>
      </nav>

      {/* Property Header */}
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 pb-6 border-b">
        <div className="flex-1 min-w-0">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground mb-3">
            {address}
          </h1>
          <div className="flex items-center gap-2 text-muted-foreground">
            <MapPin className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0" />
            <span className="text-sm sm:text-base">
              {city}, {state} {county && `• ${county} County`}
            </span>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 shrink-0">
          <Button
            onClick={onDetailsClick}
            size="lg"
            variant="outline"
            className="gap-2 text-sm sm:text-base"
          >
            <Info className="h-4 w-4 sm:h-5 sm:w-5" />
            View All Details
          </Button>
        </div>
      </div>
    </div>
  );
};
